export def getStories type, page
	let res = await Promise.any([fetch(`https://api.hnpwa.com/v0/{type}/{page}.json`), fetch(`https://api.hackerwebapp.com/{type}?page={page}`)])
	return res.json()

export def getUser id
	let res = await fetch(`https://api.hnpwa.com/v0/user/{id}.json`)
	return res.json()

export def getStory id
	let res = await fetch(`https://api.hnpwa.com/v0/item/{id}.json`)
	return res.json()